import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            flexDirection: 'column',
            textAlign: 'center',
            padding: '40px 20px'
        }}>
            <h1 style={{
                fontSize: '120px',
                marginBottom: '20px',
                color: '#093e59',
                fontWeight: 700,
                lineHeight: '1'
            }}>
                404
            </h1>
            <h2 style={{
                fontSize: '32px',
                marginBottom: '16px',
                color: '#13323f',
                fontWeight: 600
            }}>
                Page Not Found
            </h2>
            <p style={{
                fontSize: '18px',
                color: '#6b8592',
                marginBottom: '40px',
                maxWidth: '500px'
            }}>
                The page you're looking for doesn't exist.
            </p>
            <Link
                to="/"
                style={{
                    color: '#fff',
                    backgroundColor: '#0f6e8c',
                    padding: '14px 32px',
                    borderRadius: '8px',
                    textDecoration: 'none',
                    fontSize: '16px',
                    fontWeight: 600,
                    display: 'inline-block',
                    transition: 'background-color 0.3s ease'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#093e59'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#0f6e8c'}
            >
                Go Back to Home
            </Link>
        </div>
    );
}

